'use client'

import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Portal } from '@/app/_components/Portal/Portal'
import { PORTAL_SELECTORS } from '@/config/navigation.config'
import { AnchorButton } from '@/app/_components/AnchorButton'
import TXT from '@/messages'

const TicketsButton: FunctionComponent = () => (
  <Portal selector={`#${PORTAL_SELECTORS.ticketsButton}`}>
    <Link href="/">
      <AnchorButton
        weight="semibold"
        aria-label={TXT.eventsA11y.ticketsLandingPage}
        data-testid="header-tickets-button"
        className="tickets-button"
        size="sm"
        icon={(
          <Image width={24} height={24} aria-hidden="true" src="/static/svg/ticket.svg" alt={TXT.eventsA11y.linkToTicketsPage} />
        )}
      >
        {TXT.siteChrome.tickets}
      </AnchorButton>
    </Link>
  </Portal>
)

export default TicketsButton
